export const GA_MEASUREMENT_IDS = {
  "fleet-financing-beta": process.env.REACT_APP_PUBLIC_GA_FLEET__FINANCE_ID,
  "fleet-finance-distribution-journey":
    process.env.REACT_APP_PUBLIC_GA_FLEET__FINANCE_DISTRIBUTOR_ID,
};
